import ProductDatasheetPopup from '../components/simpleshop/product-datasheet-popup.vue';
export default {
    // props: [  'route', 'product', 'id', 'language_id'],
    // mixins: [BaseForm],
    // inject: [$store],
    // props: ['value'],
    components: {
        ProductDatasheetPopup
    },
    mounted() {
       console.log('####### mounted: product-list.vue');
        console.log('$root el:', this.$root.$el);
        console.log('$root id:', this.$root.$el?.id);
        console.log('$FModal:', this.$FModal);


        for (var i = 0; i < this.products_num; i++) {
            // this.$store.commit('setCollapsed', i)
            this.products_active[i] = false;
        }
        // this.$emit('input', this.products_active);
        // console.warn(this.products_active);
    },
    computed: {

    },
    watch: {
        //
        // 'products_active': {
        //
        //     handler: function(val){
        //         alert('ddd');
        //     },
        //     deep: true
        // }

    },
    methods: {

        openProductModal(product) {
            console.log('openProductModal product');
            console.log(product);
               console.log(this.$FModal);
            this.$FModal.show(
                {
                    component: ProductDatasheetPopup,
                    contentStyles: {
                        width: '100%',
                        height: '100vh',
                        marginTop: '15vh',
                        color: '#111',
                        paddingTop: '30px',
                          placement: 'bottom center'
                        // border: '4px solid grey',
                        // borderBottomLeftRadius: '25px',
                        // borderBottomRightRadius: '25px'
                    }
                },
                {
                     // text: 'bar2323'
                    product: product,
                    language_id: language_id
                }
            );
        },

        // expanded(index) {
        //      console.warn('is_expanded|'+index);
        //     // return this.global_products_active[index]
        //     if (index == this.products_active) {
        //         return true
        //     } else {
        //         return false
        //     }
        // },
        closeclick() {
            console.log('_CLOSECLICK');
            for (var i = 0; i < this.products_num; i++) {
                this.products_active[i] = false;
                this.product_active = false;
            }
            this.productwindow_open = false;
            this.$forceUpdate();

        },
        click(product, category_id) {
            if (!this.productwindow_open || this.product_active != product) {
                // console.log('_CLICKED '+product);


                for (var i = 0; i < this.products_num; i++) {
                    this.products_active[i] = false;
                }
                this.products_active[product] = !this.products_active[product];
                this.product_active = product;
                this.productwindow_open = true;
                // this.$root.product_selected = product;
                // var that = this;
                // this.$emit('input', product);
                // });
                this.$forceUpdate();
                self = this;
                setTimeout(function() {
                    self.$scrollTo('#product'+category_id+'_'+product);
                }, 300);
                // this.$nextTick(() => {
                // })
            }
        }



    },
    data: function() {
        return {
            ProductSplideSliderOptions: {
                // rewind : true,
                // type: 'loop',
                // perPage: 1,
                // width  : 1140,
                simulateTouch: false,
                 slidesPerView: 5,
                // width  : 1140,
                spaceBetween: 30,
                // gap    : '30px',
                // destroy: true,
            // on: {
            //             breakpoint: function (swiper, breakpointParams) {
            //                 if (window.innerWidth >= 1024) {
            //                     swiper.allowTouchMove = false
            //                     swiper.params.simulateTouch = false
            //                 } else {
            //                     swiper.allowTouchMove = true
            //                     swiper.params.simulateTouch = true
            //                 }
            //             },
            //             init: function (swiper) {
            //                 if (window.innerWidth >= 1024) {
            //                     swiper.allowTouchMove = false
            //                     swiper.params.simulateTouch = false
            //                 }
            //             }
            //         },
                breakpoints: {
                    320: {

                         slidesPerView: 'auto',
                        // centeredSlides: true,
                        // padding: {

                        //     left : 0,
                        //     right: '4rem'
                        // }
                    },
                    480: {
                        // destroy: 'completely',
                        // destroy: false,
                        // width:'80%',
                        slidesPerView: 1,
                        padding: {

                            left : 0,
                            right: '4rem'
                        }
                    },
                    640: {
                        // destroy: 'completely',
                        slidesPerView: 1,
                        padding: {

                            left : 0,
                            right: '4rem'
                        }
                    },
                    768: {
                        slidesPerView: 3
                        // destroy: true,
                        // arrows: false,
                        // pagination: false,
                    },
                }
            },

            products_num: 7,
            products_active: [],
            product_active: false,
            productwindow_open: false,
            // expanded: false,
            // cities: [],
            isLoading: false,
            options: [ ],
            success: '',
            error: '',
            form: {
                csrf: '',
                uid: null,

            }
        }
    }
}
